"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionKVStore = void 0;
const base_1 = require("./base");
class ExtensionKVStore extends base_1.BaseKVStore {
    constructor(prefix) {
        if (!ExtensionKVStore.KVStoreProvider) {
            if (typeof browser === "undefined") {
                console.log("You should use ExtensionKVStore on the extension environment.");
            }
            else if (!browser.storage || !browser.storage.local) {
                console.log("The 'browser' exists, but it doesn't seem to be an extension environment. This can happen in Safari browser.");
            }
            else {
                ExtensionKVStore.KVStoreProvider = {
                    get: browser.storage.local.get,
                    set: browser.storage.local.set,
                };
            }
        }
        if (!ExtensionKVStore.KVStoreProvider) {
            throw new Error("Can't initialize kv store for browser extension");
        }
        super(ExtensionKVStore.KVStoreProvider, prefix);
    }
}
exports.ExtensionKVStore = ExtensionKVStore;
//# sourceMappingURL=extension.js.map